// Id attributes for which entities will be looked up in the data to normalise.
// NOTE: Type definitions don't (and can't) use these constants; use text search to update them.
export const RULESET_SCHEMA_NAME = 'ruleSets' as const;
export const BLUEPRINTS_SCHEMA_NAME = 'blueprints' as const;
export const PROJECT_RUN_AS_USER_SCHEMA_NAME = 'projectRunAsUserSettings' as const;
